<template>
  <div class="BackendCreate">
    <el-form
        :model="user_form"
        status-icon
        :rules="user_form.id?rules_edit:rules_create"
        ref="ruleForm"
        size="medium"
        label-width="150px">

      <el-form-item label="User Name" prop="name">
        <el-input style="width: 300px" v-model="user_form.name" placeholder="Enter Name"></el-input>
      </el-form-item>

      <el-form-item label="User Email" prop="email">
        <el-input style="width: 300px" v-model="user_form.email" placeholder="Enter Email"></el-input>
      </el-form-item>

      <el-form-item label="User Role" prop="access">
        <el-select v-model="user_form.access" placeholder="Select Role">
          <el-option
              v-for="item in role_list"
              :key="item.access"
              :label="item.name"
              :value="item.access">
          </el-option>
        </el-select>
      </el-form-item>
      <template v-if="!user_form.id">
        <el-form-item label="Password" prop="pass">
          <el-input style="width: 300px" type="password" v-model="user_form.pass" autocomplete="off"
                    placeholder="Enter Password"></el-input>
        </el-form-item>

        <el-form-item label="Confirm Password" prop="check_pass">
          <el-input style="width: 300px" type="password" v-model="user_form.check_pass" autocomplete="off"
                    placeholder="Confirm Password"></el-input>
        </el-form-item>
      </template>


      <el-form-item label="Vendor Options" prop="check_list">
        <el-checkbox-group v-model="user_form.check_list">
          <el-checkbox v-for="item in option_list" :label="item.name" :key="item.num"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{uid===''?'Create':'Save'}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

  import {getBackendUser, saveBackendUser, verifyToken} from "@/utils/api";

  export default {
    props: ['uid'],
    data() {
      let validateEmail = (rule, value, callback) => {
        let reg = new RegExp("^[A-Za-z0-9]+([._\\-]*[A-Za-z0-9])*@([A-Za-z0-9]+[-A-Za-z0-9]*[A-Za-z0-9]+.){1,63}[A-Za-z0-9]+$");
        if (value === "") {
          callback(new Error('Email is required'));
        } else if (!reg.test(value)) {
          callback(new Error('Invalid Email'));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Password is required'));
        } else {
          if (this.user_form.check_pass !== '') {
            this.$refs.ruleForm.validateField('check_pass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Enter password again'));
        } else if (value !== this.user_form.pass) {
          callback(new Error('Password mismatch!'));
        } else {
          callback();
        }
      };
      return {
        option_list: [
          {
            name: 'Rating',
            num: 1
          },
          {
            name: 'Comment',
            num: 2
          },
          {
            name: 'Video',
            num: 3
          }
        ],
        role_list: [
          {
            access: 1,
            name: 'Admin'
          }, {
            access: 2,
            name: 'Vendor'
          },
        ],
        current_user: {},
        user_form: {
          id: '',
          name: '',
          email: '',
          access: '',
          pass: '',
          check_pass: '',
          check_list: []
        },
        rules_create: {
          name: [
            {required: true, message: 'Name is required', trigger: 'blur'},
          ],
          email: [
            {required: true, message: 'Email is required', trigger: 'blur'},
            {validator: validateEmail, trigger: 'blur'}
          ],
          access: [
            {required: true, message: 'User role is required', trigger: 'change'},
          ],
          pass: [
            {required: true, message: 'Password is required', trigger: 'blur'},
            {validator: validatePass, trigger: 'blur'}
          ],
          check_pass: [
            {required: true, message: 'Enter password again', trigger: 'blur'},
            {validator: validatePass2, trigger: 'blur'}
          ],

        },
        rules_edit: {
          name: [
            {required: true, message: 'Name is required', trigger: 'blur'},
          ],
          email: [
            {required: true, message: 'Email is required', trigger: 'blur'},
            {validator: validateEmail, trigger: 'blur'}
          ],
          access: [
            {required: true, message: 'User role is required', trigger: 'change'},
          ],
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            saveBackendUser(this.user_form).then(res => {
              if (res.errcode === 0) {
                this.$message.success('User Saved!');
                this.$emit('update');
                verifyToken().then(res => {
                  if (res.errcode !== 0) {
                    this.$router.replace('/login')
                  }
                })
              } else if (res.errcode === 1) {
                this.$message.error('Error');
              } else if (res.errcode === 2) {
                this.$message.error('Email has been taken');
              }
            })
          } else {
            this.$message.warning('Check your inputs')
          }
        });
      },
    },
    beforeMount() {
      if (this.uid !== '') {

        getBackendUser(this.uid).then(res => {
          let user = res.backend_list[0];
          let check_list = [];
          if (user.rate_enable) {
            check_list.push('Rating')
          }
          if (user.review_enable) {
            check_list.push('Comment')
          }
          if (user.video_enable) {
            check_list.push('Video')
          }
          this.user_form = {
            id: user.user_id,
            name: user.user_name,
            email: user.user_email,
            access: user.user_access,
            pass: '',
            check_pass: '',
            check_list: check_list
          }
        })
      }
    }
  };
</script>
